module.exports = __webpack_public_path__ + "img/member-bg.ce905dc.jpg";